import RightImage from 'images/team/intro/1_right.png';
import React from 'react';
import styled from 'styled-components';
import { Grid } from '@material-ui/core';
import Img from 'gatsby-image';
import { breakpoint } from 'utils/mediaQueries';

const GridImages = styled(Grid)`
  position: relative;
`;

const RightImg = styled(Img)`
  width: 100%;
  align-items: center;
  align-self: center;
  &:nth-child(1) {
    display: none;
    ${breakpoint.down('md')`
  display: block;width:50%;margin-left: 13%;align-self:center`}
  }
  &:nth-child(2) {
    align-self: center;
  }
  &:nth-child(3) {
    width: 85%;
    ${breakpoint.down('md')`
  display: none`}
  }
  &:nth-child(4) {
    width: 45%;
    ${breakpoint.down('md')`
  width: 35%; margin-right: -5%; margin-top:-10%`}
  }
`;
const LittleImgRight = styled.img`
  position: absolute;
  width: 22%;
  ${breakpoint.down('md')`
  display: none`};
  top: -10%;
  left: -14%;
`;
const BlockImageRight = ({ data }) => {
  return (
    <GridImages container wrap={'nowrap'}>
      {data.map((image, index) => {
        return (
          <RightImg
            fluid={image.childImageSharp.fluid}
            key={`RightImg${index}`}
          />
        );
      })}
      <LittleImgRight src={RightImage} alt="Little image right" />
    </GridImages>
  );
};
export default BlockImageRight;
